var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip",
          value: { html: true, boundary: "window" },
          expression: "{html: true, boundary: 'window'}"
        }
      ],
      attrs: {
        title:
          _vm.characteristic.description &&
          (!_vm.descriptionConfig || !_vm.descriptionConfig.inline)
            ? _vm.characteristic.description
            : undefined
      }
    },
    [
      _c(
        "span",
        { staticClass: "characteristic-select-inline--item-label-label" },
        [
          _c("Label", {
            attrs: {
              characteristic: _vm.characteristic,
              "label-type": _vm.labelType,
              "highlight-words": _vm.highlightWords
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasIcon
        ? _c(
            "span",
            { staticClass: "characteristic-select-inline--label-icon" },
            [
              _c("img", {
                attrs: {
                  src:
                    _vm.iconPath + "/" + _vm.characteristic.naturalId + ".svg",
                  alt: _vm.label
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.characteristic.description
        ? _c(
            "span",
            {
              class: {
                "characteristic-select-inline--item-description": true,
                "characteristic-select-inline--item-description-html":
                  _vm.isDescriptionHtml
              }
            },
            [
              _vm.descriptionConfig && _vm.descriptionConfig.inline
                ? [
                    _vm.isDescriptionHtml
                      ? _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.characteristic.description)
                          }
                        })
                      : [
                          _vm._v(
                            _vm._s(
                              _vm._f("stripTags")(
                                _vm.characteristic.description
                              )
                            )
                          )
                        ]
                  ]
                : _c("Icon", { attrs: { icon: "info" } })
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }